__turbopack_context__.v({
  "container": "PageLayout-module-scss-module__cDPNka__container",
  "footer": "PageLayout-module-scss-module__cDPNka__footer",
  "footerCopyright": "PageLayout-module-scss-module__cDPNka__footerCopyright",
  "footerInner": "PageLayout-module-scss-module__cDPNka__footerInner",
  "footerLink": "PageLayout-module-scss-module__cDPNka__footerLink",
  "footerLinkButton": "PageLayout-module-scss-module__cDPNka__footerLinkButton",
  "footerLinks": "PageLayout-module-scss-module__cDPNka__footerLinks",
  "footerSeparator": "PageLayout-module-scss-module__cDPNka__footerSeparator",
  "main": "PageLayout-module-scss-module__cDPNka__main",
});
